import React, { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material/styles';
import { AiFillEye } from 'react-icons/ai';
import { Box, IconButton } from '@mui/material';
import ViewAuditLog from '../ViewAuditLog';
import FormatCreatedAtDate from '@projectK/modules/apps/DateFormat';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 8,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },
  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },
  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },
    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
}));
const formatRoleName = (roleName) => {
  if (!roleName) return '-'; // Return empty string if undefined or null
  return roleName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
const TableItem = ({ data, models }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
  };

  const localDate = data.created_at ? (
    <FormatCreatedAtDate
      date={data.created_at}
      showDate={true}
      showTime={true}
    />
  ) : (
    '-'
  );
const roleFormat = formatRoleName(data.actual_role);
  return (
    <TableRow key={data.id} className='item-hover'>
      <StyledTableCell align='left'>
        <Box className='textwrap'>{data.action}</Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        <Box className='textwrap'>{data.userName || '-'}</Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        <Box className='textwrap'>{formatRoleName(data.user_role)}</Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        <Box className='textwrap'>{data.created_userName || '-'}</Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        <Box className='textwrap'>{roleFormat || '-'}</Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        <Box className='textwrap1'>
          {models.find((m) => m.key === data.model)?.label || data.model}
        </Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        {localDate}
      </StyledTableCell>
      <StyledTableCell align='center'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconButton
            size='small'
            className='icon-btn icon-btn-eye'
            onClick={handleEditClick}
          >
            <AiFillEye />
          </IconButton>
        </div>
      </StyledTableCell>
      {isEditModalOpen && (
        <ViewAuditLog
          emailtemplateData={data}
          isQueue={false}
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          localDate={localDate}
          models={models}
        />
      )}
    </TableRow>
  );
};

export default TableItem;

TableItem.propTypes = {
  data: PropTypes.object.isRequired,
  models: PropTypes.array,
};
